var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckMarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32798 9.1284C3.0387 8.83194 2.56386 8.82613 2.2674 9.11541C1.97094 9.4047 1.96513 9.87954 2.25442 10.176L3.32798 9.1284ZM6.30239 13.2504L5.7656 13.7742C5.92413 13.9367 6.14769 14.0186 6.37364 13.997C6.59959 13.9755 6.80362 13.8527 6.92855 13.6632L6.30239 13.2504ZM13.8348 3.18775C14.0628 2.84193 13.9673 2.37676 13.6215 2.14877C13.2757 1.92078 12.8105 2.01629 12.5825 2.36212L13.8348 3.18775ZM2.25442 10.176L5.7656 13.7742L6.83917 12.7266L3.32798 9.1284L2.25442 10.176ZM6.92855 13.6632L13.8348 3.18775L12.5825 2.36212L5.67622 12.8376L6.92855 13.6632Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkIcon);
export default __webpack_public_path__ + "static/media/check-mark-icon.48626600b5b2f9cd7cfb9a790e1fdcdc.svg";
export { ForwardRef as ReactComponent };